import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import courierService from "./courierService";

const errMsg = (error) =>
  error.response?.data?.message || error.message || "Something went wrong";

const makeThunk = (type, fn) =>
  createAsyncThunk(type, async (arg, thunkAPI) => {
    try {
      return await fn(arg);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || { message: errMsg(error) });
    }
  });

export const fetchCouriers = makeThunk("courier/fetchAll", async () => (await courierService.getAll()).data);
export const createCourier = makeThunk("courier/create", async (data) => (await courierService.create(data)).data);
export const deleteCourier = makeThunk("courier/delete", async (id) => {
  await courierService.remove(id);
  return id;
});

const courierSlice = createSlice({
  name: "courier",
  initialState: { list: [], isSaving: false, isError: false, message: "" },
  reducers: {
    clearCourierError: (s) => { s.isError = false; s.message = ""; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCouriers.fulfilled, (s, a) => { s.list = a.payload; })

      .addCase(createCourier.pending, (s) => { s.isSaving = true; s.isError = false; s.message = ""; })
      .addCase(createCourier.fulfilled, (s, a) => {
        s.isSaving = false;
        s.list = [...s.list, a.payload].sort((x, y) => x.name.localeCompare(y.name));
      })
      .addCase(createCourier.rejected, (s, a) => {
        s.isSaving = false; s.isError = true;
        s.message = a.payload?.message || "Could not add courier";
      })

      .addCase(deleteCourier.pending, (s) => { s.isSaving = true; s.isError = false; s.message = ""; })
      .addCase(deleteCourier.fulfilled, (s, a) => {
        s.isSaving = false;
        s.list = s.list.filter((c) => c.id !== a.payload);
      })
      .addCase(deleteCourier.rejected, (s, a) => {
        s.isSaving = false; s.isError = true;
        s.message = a.payload?.message || "Could not delete courier";
      });
  },
});

export const { clearCourierError } = courierSlice.actions;
export default courierSlice.reducer;